module.exports = __webpack_public_path__ + "img/nav-design-fancy.c2b356c.webp";